import Tabs from '@eduzz/houston-ui/Tabs';
import { Button, Grid, Icon } from '@material-ui/core';
import type { StyledComponentProps } from '@material-ui/core/styles';
import PermissionHide from 'components/PermissionHide';
import { functions } from 'helpers';
import type { RefObject } from 'react';
import { memo } from 'react';
import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { listCoProductions, listMyProducts } from 'store/Orbita/Product/actions';
import TopPage from 'v2/components/Shared/TopPage';
import ProductsTour from 'v2/components/Shared/Tour';

import CoProductions from './components/CoProductions';
import { InputProductSearch } from './components/InputProductSearch';
import ProductTable from './components/ProductTable';
import QuickView from './components/QuickView';
import styles from './styles';
import { productTourSteps } from './tour';

import type { InputProductSearchType } from './components/InputProductSearch';
import type { PaginationType } from './components/ProductTable';
import type { DispatchProp } from 'react-redux';
import type { RouteComponentProps } from 'react-router-dom';

const tabs = ['Todos', 'Aprovados', 'Em Análise', 'Reprovados'];

interface IRouteParams {
  tab?: any;
}

interface IPropsFromConnect {
  products: any;
  pagination: any;
  isFetching: any;
  childrenOpen: any;
  listProductsChildren: any;
  isCompleted: any;
  currentUser: any;
}
interface IProps extends DispatchProp<any>, IPropsFromConnect, StyledComponentProps, RouteComponentProps<IRouteParams> {}

interface IStates {
  viewType: any;
  tab: any;
  activeMenu: null;
  activeQuickView: boolean;
  filters: { moderation_status: string; status: string; order: string };
  idProduct: number;
  searchValue: string;
  collapseExpanded: number;
  dataProduct: any;
  dataActivatedChildren: any;
}

enum TabsIndexes {
  ALL = 0,
  APPROVED = 1,
  PENDING = 2,
  REPROVED = 3,
  COPRODUCTIONS = 4,
}

class MyContents extends Component<IProps, IStates> {
  private pageLoad = {
    startTime: 0,
    completed: false,
  };

  private tabsRef: RefObject<HTMLButtonElement>;

  constructor(props: IProps) {
    super(props);
    this.pageLoad.startTime = performance.now();
    this.callMoreData = this.callMoreData.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
    this.handleSearchEnter = this.handleSearchEnter.bind(this);
    this.onClickOptions = this.onClickOptions.bind(this);

    this.onChangeSearch = this.onChangeSearch.bind(this);

    this.onEditProduct = this.onEditProduct.bind(this);

    this.state = {
      viewType: 1,
      activeMenu: null,
      tab: TabsIndexes.ALL,
      filters: {
        moderation_status: '',
        status: '',
        order: 'created_at-desc',
      },
      activeQuickView: false,
      idProduct: null,
      searchValue: '',
      collapseExpanded: 0,
      dataProduct: null,
      dataActivatedChildren: null,
    };

    this.tabsRef = createRef();
  }

  handleTabChange(value: number) {
    const { pagination } = this.props;
    const { filters } = this.state;

    this.setState({ tab: value });

    if (value !== TabsIndexes.COPRODUCTIONS) {
      let newFilters = { status: '', moderation_status: '', order: '' };

      const moderationStatusMap = ['all', 'approved', 'pendding', 'reproved', 'coproductions'];

      newFilters.moderation_status = moderationStatusMap[value];
      newFilters.order = filters.order;

      this.setState({ filters: newFilters, searchValue: '' });

      if (pagination && pagination.per_page) {
        this.callMoreData(newFilters, { current_page: 1, per_page: pagination.per_page });
        return;
      }

      this.callMoreData(newFilters, { current_page: 1, per_page: 10 });
    }

    this.setState({ searchValue: '' });
  }

  onChangeSearch(e: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ searchValue: e.target.value });
  }

  handleSearchEnter(value: string) {
    const { tab } = this.state;
    const pagination = { current_page: 1, per_page: 20, total_pages: 0, total_items: 0 };

    if (tab === TabsIndexes.COPRODUCTIONS) {
      (async () => {
        try {
          await this.props.dispatch(listCoProductions(pagination, value));
        } catch (error) {
          toast.error(error);
        }
      })();
    } else {
      this.callMoreData({ ...this.state.filters, title: value }, { current_page: 1, per_page: this.props.pagination?.per_page || 20 });
    }
  }

  callMoreData(filters: any, pagination: any) {
    (async () => {
      try {
        await this.props.dispatch(listMyProducts(filters, pagination));
      } catch (error) {
        toast.error(error);
      }
    })();
  }

  onShowSizeChange(current: any, size: any) {
    this.callMoreData({ ...this.state.filters, title: this.state.searchValue }, { current_page: current, per_page: size });
  }

  onChangePagination(page: any) {
    this.onShowSizeChange(page, this.props.pagination.per_page);
  }

  onChangeRowsPerPage = (per_page: number) => {
    this.callMoreData({ ...this.state.filters, title: this.state.searchValue }, { ...this.props.pagination, ...{ current_page: 1, per_page } });
  };

  onChangePage = (page: number) => {
    this.callMoreData({ ...this.state.filters, title: this.state.searchValue }, { ...this.props.pagination, ...{ current_page: page } });
  };

  onClickOptions(product: any, activatedChildren: any) {
    this.setState({
      idProduct: product.id,
      activeQuickView: true,
      dataProduct: product,
      dataActivatedChildren: activatedChildren,
    });
  }

  onEditProduct() {
    if (this.state.searchValue) {
      this.handleSearchEnter(this.state.searchValue);
    } else {
      this.callMoreData(this.state.filters, this.props.pagination);
    }

    this.setState({ collapseExpanded: 0 });
  }

  onSort = (field: string, direction: 'asc' | 'desc') => {
    const newFilters = { status: '', moderation_status: '', order: '' };
    newFilters.moderation_status = this.state.filters.moderation_status;
    newFilters.status = this.state.filters.status;
    newFilters.order = `${field}-${direction}`;

    this.setState({
      filters: newFilters,
    });

    this.callMoreData(newFilters, this.props.pagination);
  };

  handlePressEnter = (e: any) => {
    if (e.key === 'Enter') {
      this.handleSearchEnter(this.state.searchValue);
    }
  };
  componentDidMount() {
    let params = this.props.match.params;
    if (params && params.tab === 'approved') {
      this.setState({ tab: TabsIndexes.APPROVED });
      this.callMoreData({ moderation_status: 'approved', order: 'created_at-desc' }, { current_page: 1, per_page: 10 });
    } else if (params && params.tab === 'reproved') {
      this.setState({ tab: TabsIndexes.REPROVED });
      this.callMoreData({ moderation_status: 'reproved', order: 'created_at-desc' }, { current_page: 1, per_page: 10 });
    } else {
      this.callMoreData({ order: 'created_at-desc' }, { current_page: 1, per_page: 10 });
    }
  }

  componentDidUpdate() {
    if (!this.pageLoad.completed && this.props.isCompleted) {
      this.pageLoad.completed = true;
      //this.props.dispatch(savePageLoad('Meus Produtos', performance.now() - this.pageLoad.startTime));
    }

    this.state.activeQuickView ? functions.removeScrollPage() : functions.addScrollPage();
  }

  render() {
    const products = this.props.products;
    const pagination = this.props.pagination;
    const { classes } = this.props;

    return (
      <div className={classes.root} id='my-products'>
        <TopPage
          title='Meus Produtos'
          action={
            <PermissionHide action='myeduzz:meus-produtos:criar'>
              <Link to={'/producer/product/newproduct'}>
                <Button id='myNewProductButton' color='secondary' variant='contained'>
                  <Icon style={{ fontSize: 20, marginRight: 8 }}>add</Icon> Criar Novo Produto
                </Button>
              </Link>
            </PermissionHide>
          }
        />

        <Grid container justify='space-between' alignItems='center' spacing={2}>
          <Grid item xs={12}>
            <Tabs value={this.state.tab} onChange={this.handleTabChange} style={{ paddingBottom: 16 }}>
              {tabs.map((t) => (
                <Tabs.Tab key={t} label={t}>
                  <TabProductContent
                    table={{
                      products,
                      order: this.state.filters.order,
                      listChildren: this.props.listProductsChildren,
                      onSort: this.onSort,
                      onClickOptions: this.onClickOptions,
                      isLoading: this.props.isFetching,
                      pagination: {
                        current_page: pagination?.current_page ?? 1,
                        per_page: pagination?.per_page ?? 10,
                        total: pagination?.total_items,
                        optionsPerPage: '10,20,30,40',
                        onChangePage: this.onChangePage,
                        onChangePerPage: this.onChangeRowsPerPage,
                      },
                    }}
                    inputSearch={{
                      onChange: this.onChangeSearch,
                      onKeyPress: this.handlePressEnter,
                      value: this.state.searchValue,
                      classes: this.props.classes,
                      handleSearchEnter: this.handleSearchEnter,
                    }}
                  />
                </Tabs.Tab>
              ))}
              <Tabs.Tab label='Co-Produções'>
                <InputProductSearch
                  classes={this.props.classes}
                  onChange={this.onChangeSearch}
                  onKeyPress={this.handlePressEnter}
                  value={this.state.searchValue}
                  handleSearchEnter={this.handlePressEnter}
                />
                <CoProductions user={this.props.currentUser} search={this.state.searchValue} />
              </Tabs.Tab>
            </Tabs>
          </Grid>
        </Grid>
        <QuickView
          active={this.state.activeQuickView}
          changeActive={() => {
            this.setState({ activeQuickView: !this.state.activeQuickView });
          }}
          onEditProduct={this.onEditProduct}
          productData={this.state.dataProduct}
          activatedChildren={this.state.dataActivatedChildren}
        />
      </div>
    );
  }
}

type TableType = {
  products: any;
  order: any;
  listChildren: any;
  onSort: any;
  onClickOptions: any;
  isLoading: boolean;
  pagination: PaginationType;
};

const TabProductContent = memo(({ table, inputSearch }: { table: TableType; inputSearch: InputProductSearchType }) => {
  return (
    <div id='myProductsList'>
      <InputProductSearch {...inputSearch} />
      <ProductsTour name='products_tour' steps={productTourSteps} />
      <ProductTable {...table} />
    </div>
  );
});

function mapStateToProps(state: any) {
  return {
    products: state.orbita.Product.listMine.data,
    pagination: state.orbita.Product.listMine.pagination,
    isFetching: state.orbita.Product.listMine.isFetching,
    childrenOpen: state.orbita.Product.listProductsChildren.data,
    listProductsChildren: state.orbita.Product.listProductsChildren,
    isCompleted: Array.isArray(state.orbita.Product.listMine.data),
    currentUser: state.orbita.User.user.user,
  };
}
export default connect(mapStateToProps)(styles(MyContents));
